import { render, staticRenderFns } from "./Geschillenorganisatie.vue?vue&type=template&id=663b36b1&"
import script from "./Geschillenorganisatie.vue?vue&type=script&lang=js&"
export * from "./Geschillenorganisatie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports